export interface UpgradeableConfig<Upgrades> {
  upgradesPerformed?: Upgrades;
}

export function hasPerformedUpgrade<Upgrades>(meta: UpgradeableConfig<Upgrades>, upgrade: keyof Upgrades) {
  return meta.upgradesPerformed && meta.upgradesPerformed[upgrade];
}
